export default () => {

  const s = {}
  const init = () => {
    s.root = document.querySelector('.ti-sticky');
    if (!s.root) {
      return
    }
    console.log('build studium accordion')

    bindStudiumAccordionAction();
    bindScrollFixedBottomAction();
  }

  const bindStudiumAccordionAction = () => {
    s.btn = s.root.querySelector('.ti-sticky__btn');
    s.accrodionBody = s.root.querySelector('.ti-sticky__body');
    s.accrodionEntity = s.root.querySelector('.ti-sticky__inner');

    s.btn.addEventListener('click', () => {
      if (s.root.classList.contains('is-open')) {
        s.accrodionBody.style.height = '';
        s.root.classList.remove('is-open');
      } else {
        s.accrodionBody.style.height = `${s.accrodionEntity.clientHeight}px`;
        s.root.classList.add('is-open');
      }
    })
  }

  const bindScrollFixedBottomAction = () => {
    const limitBottomBaseElement = document.querySelector('.ti-body__seat');
    window.addEventListener('scroll', () => {
      const limitBottomPos = limitBottomBaseElement.getBoundingClientRect().bottom;
      const accordionBottomPos = s.accrodionBody.getBoundingClientRect().bottom
      if (s.root.classList.contains('is-open')
        && limitBottomPos < accordionBottomPos) {
          s.accrodionBody.style.height = '';
          s.root.classList.remove('is-open');
      }
    })
  }

  init();
}
